import type { AiIconKey } from '@caddie/ui-kit/components/icons';
import { SuperBarViewState } from '../context/use-chat-context';
import { cn } from '../utils/styles';

// Icons with a published CDN loading animation render animated; everything else
// renders static. Add an icon here once its animation assets ship to the CDN.
export const ANIMATED_AI_ICONS: ReadonlySet<AiIconKey> = new Set<AiIconKey>([
  'icon5',
]);

export const iconSlotSizeClasses = (
  superBarViewState: SuperBarViewState
): string =>
  cn(
    superBarViewState === SuperBarViewState.MINIMIZED &&
      'caddietw-w-[34px] caddietw-h-[34px]',
    (superBarViewState === SuperBarViewState.DEFAULT ||
      superBarViewState === SuperBarViewState.DISPLAYING_ANSWER ||
      superBarViewState === SuperBarViewState.EXPANDED) &&
      'caddietw-w-[40px] caddietw-h-[40px]'
  );
